import { phpAuthUser, phpAvatarPaths } from "../../core/php-data-access";
import { avatarForm } from "./avatar-form";

export class AvatarRender {
    private static revealAvatarImage(img: HTMLImageElement | null): void {
        if (!img) return;

        img.classList.remove("is-hidden");
        img.style.display = "";

        const placeholder = img.nextElementSibling;
        if (placeholder instanceof HTMLElement) {
            placeholder.style.display = "none";
        }
    }

    public static previewFileToImage(img: HTMLImageElement | null, file: File): void {
        if (!img) return;
        const reader = new FileReader();
        reader.onload = (event: ProgressEvent<FileReader>) => {
            const result = event.target?.result;
            if (typeof result === "string") {
                img.src = result;
                AvatarRender.revealAvatarImage(img);
            }
        };
        reader.readAsDataURL(file);
    }

    public static updateAvatarImages(userId: number, avatarUrl: string): void {
        const cacheBustedUrl = `${avatarUrl}?t=${Date.now()}`;

        for (const avatarImage of avatarForm.getAvatarImages(document)) {
            avatarImage.src = cacheBustedUrl;
            AvatarRender.revealAvatarImage(avatarImage);
            if (!avatarImage.alt || avatarImage.alt.trim() === "") {
                avatarImage.alt = `User ${userId}`;
            }
        }

        const modalPreview = avatarForm.getAvatarPreview(document);
        if (modalPreview instanceof HTMLImageElement) {
            modalPreview.src = cacheBustedUrl;
            modalPreview.setAttribute("data-original-src", cacheBustedUrl);
            AvatarRender.revealAvatarImage(modalPreview);
        }

        const authUser = phpAuthUser() as unknown as Record<string, unknown> | null;
        if (authUser) {
            authUser.avatar = avatarUrl;
        }
    }

    public static buildFinalAvatarUrl(
        filename: string | null | undefined,
        avatarUrl: string | null | undefined,
    ): string {
        const avatarPath = phpAvatarPaths()?.urlPath;
        const base = typeof avatarPath === "string" && avatarPath.trim() !== "" ? avatarPath.replace(/\/+$/, "") : null;
        if (filename && base) return `${base}/${filename}`;
        return avatarUrl || "";
    }
}
